exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logout-main-container {\n  margin-top: 25rem;\n  text-align: center;\n  font-size: 4rem; }\n  .logout-main-container .logout-text .red-text {\n    color: red; }\n", ""]);

// exports
